import { Component, OnInit } from '@angular/core';
import { Constants } from 'src/app/app.constants';
import { MatDialog } from '@angular/material/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { AuthService, MerchantService } from 'src/app/services';
import { IntegrationDetailDialogComponent } from './integration-detail-dialog/integration-detail-dialog.component';
import { IntegrationConfig } from 'src/app/models';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiIntegrationDialogComponent } from './api-integration-dialog/api-integration-dialog.component';

export interface Integration {
  label: string;
  value: string;
  image: string;
  active: boolean;
  tags: string[];
  link: string;
}

@Component({
  selector: 'integrations-home',
  templateUrl: 'integrations-home.component.html',
  styleUrls: ['./integrations-home.component.css'],
})
export class IntegrationsHomeComponent implements OnInit {
  title = '';
  subtitle: string = '';

  activeIntegrations: IntegrationConfig[] = [];

  integrations: Integration[] = [
    {
      label: 'API',
      value: 'api',
      image: '../../../assets/api-integration.svg',
      active: false,
      tags: ['Developer API'],
      link: 'https://developer.remyrewards.co.uk',
    },
    {
      label: 'Shopify',
      value: 'shopify',
      image: '../../../assets/shopify-logo.png',
      active: false,
      tags: ['Online', 'Epos'],
      link: 'https://www.shopify.com',
    },
    {
      label: 'Square',
      value: 'square',
      image: '../../../assets/square-logo.png',
      active: false,
      tags: ['Online', 'Epos'],
      link: 'https://squareup.com',
    },
    {
      label: 'Zapier',
      value: 'zapier',
      image: '../../../assets/Zapier_logo.jpg',
      active: false,
      tags: ['7000+ Integrations'],
      link: 'https://zapier.com',
    },
    {
      label: 'Make',
      value: 'make',
      image: '../../../assets/make.png',
      active: false,
      tags: ['300+ Integrations'],
      link: 'https://eu1.make.com/app/invite/eda18640740df7d85b49553ea02ad21f',
    },
  ];

  saving = false;
  loading = false;
  error = false;

  merchantActive = false;

  constructor(
    public constants: Constants,
    public dialog: MatDialog,
    private authService: AuthService,
    private merchantService: MerchantService,
  ) {}

  ngOnInit() {
    this.merchantActive = this.authService.merchantObj?.active ?? true;

    this.subtitle = this.authService.getNestedUserProperty('merchant', 'name');

    this.getActiveIntegrations();
  }

  getActiveIntegrations(): void {
    this.loading = true;
    this.merchantService
      .getActiveIntegrations()
      .subscribe({
        next: (res: IntegrationConfig[]) => {
          if (res) {
            this.activeIntegrations = res;

            this.integrations.forEach((el) => {
              el.active = false;
              const activeIntegration = this.activeIntegrations.find(
                (i) => i.integrationType === el.value,
              );
              if (activeIntegration) {
                el.active = true;
              }
            });
          }
        },
        error: (res: HttpErrorResponse) => {
          this.constants.snack(res.error.message);
        },
      })
      .add(() => (this.loading = false));
  }

  onIntegrationClick(value: Integration) {
    const component = value.value === 'api'
      ? ApiIntegrationDialogComponent
      : IntegrationDetailDialogComponent;
    const dialogRef = this.dialog.open<any>(component as any, {
      data: {
        integration: value,
      },
      scrollStrategy: new NoopScrollStrategy(),
      autoFocus: false,
      width: '750px',
      disableClose: true,
      panelClass: 'custom-dialog',
    });
    dialogRef.afterClosed().subscribe(() => this.getActiveIntegrations());
  }
}
